/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Bankovní účet.
 */
export interface PropertyRequestAccount { 
    accountNumber?: string;
    bankCode?: string;
}

